/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Orders_Title6Inputs */

const en_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-assisted order taking`)
};

const ar_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استقبال الطلبات بالذكاء الاصطناعي`)
};

const bn_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই-সহায়তায় অর্ডার নেওয়া`)
};

const de_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestützte Bestellannahme`)
};

const es_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma de pedidos asistida por IA`)
};

const fr_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prise de commande assistée par IA`)
};

const pt_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atendimento de pedidos com IA`)
};

const zh_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 辅助接单`)
};

const tr_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ destekli sipariş alma`)
};

const ru_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приём заказов с ИИ`)
};

const pl_svc_messaging_bots_orders_title6 = /** @type {(inputs: Svc_Messaging_Bots_Orders_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjmowanie zamówień z AI`)
};

/**
* | output |
* | --- |
* | "AI-assisted order taking" |
*
* @param {Svc_Messaging_Bots_Orders_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_orders_title6 = /** @type {((inputs?: Svc_Messaging_Bots_Orders_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Orders_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_orders_title6(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_orders_title6(inputs)
	if (locale === "de") return de_svc_messaging_bots_orders_title6(inputs)
	if (locale === "es") return es_svc_messaging_bots_orders_title6(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_orders_title6(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_orders_title6(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_orders_title6(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_orders_title6(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_orders_title6(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_orders_title6(inputs)
	return en_svc_messaging_bots_orders_title6(inputs)
});
export { svc_messaging_bots_orders_title6 as "svc_messaging-bots_ORDERS_title" }